// Режим «Траекторий по HSI»: статичные усики или кометы. Одно решение на всех —
// эффект статики, такт анимации, кнопку и запись ролика.
//
// Запись учитывается ЯВНО, а не через «нажата ли кнопка анимации». Бой
// 14.09.2026: на маке с системным «Уменьшить движение» запись поднимала
// `hsiAnim`, но кометы не «шли» (reduced) — статика оставалась на карте, а кадр
// записи всё равно рисовал кометы, и ролик вышел с анимацией ПОВЕРХ усиков.
// «Меньше движения» — про анимацию на экране; ролик человек заказал сам, и
// показывает он ту же картину, что и у всех: кометы вместо статики.

export interface CometModeInput {
  /** Слой «Траектории по HSI» включён (и вид выбран). */
  enabled: boolean
  /** Сколько усиков в выборке. */
  trails: number
  /** Системная настройка `prefers-reduced-motion`. */
  reduced: boolean
  /** Человек нажал «Анимация». */
  animate: boolean
  /** Идёт запись ролика. */
  recording: boolean
}

export interface CometMode {
  /** Кометы есть чем показать в ролике. */
  recordable: boolean
  /** Кнопку «Анимация» можно нажать. */
  canAnimate: boolean
  /** Кометы на карте сейчас — и ТОЛЬКО тогда статика снята. */
  running: boolean
}

export function cometMode(i: CometModeInput): CometMode {
  const available = i.enabled && i.trails > 0
  return {
    recordable: available,
    canAnimate: available && !i.reduced,
    running: available && (i.recording || (i.animate && !i.reduced)),
  }
}
